import en from './content.en';
import fr from './content.fr';
import de from './content.de';
import it from './content.it';
import es from './content.es';
import pt from './content.pt';

const ALL = { en, fr, de, it, es, pt };

export function getLegalContent(lang) {
  return ALL[lang] || ALL.en;
}

export const LEGAL_LANGS = Object.keys(ALL);
export default ALL;
